import type { AmbleContent } from "../..";
import { wholesalerContactInfoAgentEmailCopy } from "../../shared/wholesaler-contact-info";

const getAffordableQuotes =
  "<p>Thank you for using Simply Business to get a quote for your small business client.</p><p>Your agent details have been submitted by First Connect in the background and will be linked by Simply Business to every quote and policy you create.</p>";

export const ambles: Record<string, AmbleContent> = {
  usa_business_get_affordable_quotes: getAffordableQuotes,
  usa_wholesaler_contact_information: wholesalerContactInfoAgentEmailCopy,
};
